module.exports = __webpack_public_path__ + "img/detailQrcode.5410f286.jpeg";